(function(){
  'use strict';

  var waveBackgroundUrl = 'https://cdn.shopify.com/s/files/1/0260/1166/4439/files/ChatGPT_Image_Sep_13_2026_06_37_17_PM_1.webp?v=1789321199';
  var subscribeArtUrl = 'https://cdn.shopify.com/s/files/1/0260/1166/4439/files/ChatGPT_Image_Sep_13_2026_06_36_46_PM.webp?v=1789321275';

  function applyProductWaveBackground(){
    var body = document.body;
    if(!body || !body.classList.contains('js-product-page')) return;

    var targets = [body, document.getElementById('tt-pageContent')];
    targets.forEach(function(el){
      if(!el) return;
      el.style.setProperty('background-color', '#23b4ee', 'important');
      el.style.setProperty('background-image', 'url("' + waveBackgroundUrl + '")', 'important');
      el.style.setProperty('background-repeat', 'repeat', 'important');
      el.style.setProperty('background-position', '0 0', 'important');
      el.style.setProperty('background-size', '720px auto', 'important');
    });
  }

  function init(root){
    if(!root || root.dataset.jscharReady === '1') return;
    root.dataset.jscharReady = '1';

    var track = root.querySelector('[data-jschar-track]');
    var character = root.querySelector('[data-jschar-character]');
    var input = root.querySelector('[data-jschar-email]');
    var form = root.querySelector('form');
    var eyes = root.querySelectorAll('[data-jschar-eye]');
    if(!track || !character || !input || !form) return;

    /* Build the footer layout (mascot | centred form | artwork) without touching the Shopify form or mascot SVG.
       The old "JOIN THE JUSTSMOKE CREW" copy block was removed on request (2026-10-04). */
    var art = root.querySelector('.jschar-art-placeholder');
    if(!art){
      art = document.createElement('div');
      art.className = 'jschar-art-placeholder jschar-art-image';
      root.appendChild(art);
    }
    art.classList.add('jschar-art-image');
    art.setAttribute('aria-label','JustSmoke newsletter artwork');
    art.innerHTML = '';
    art.style.setProperty('border','0','important');
    art.style.setProperty('background','transparent','important');
    art.style.setProperty('box-shadow','none','important');
    art.style.setProperty('overflow','hidden','important');

    var artImg = document.createElement('img');
    artImg.src = subscribeArtUrl;
    artImg.alt = 'JustSmoke newsletter shark artwork';
    artImg.loading = 'lazy';
    artImg.style.display = 'block';
    artImg.style.width = '100%';
    artImg.style.height = '100%';
    artImg.style.objectFit = 'contain';
    artImg.style.objectPosition = 'center';
    art.appendChild(artImg);

    var dragging = false;
    var startX = 0;
    var startOffset = 0;
    var currentOffset = 0;

    function bounds(){ return Math.max(0, track.clientWidth - 232); }
    function clamp(v,min,max){ return Math.min(max,Math.max(min,v)); }
    function setX(v){ currentOffset = clamp(v,0,bounds()); character.style.setProperty('--chx', currentOffset + 'px'); }
    function center(){ setX(bounds()/2); }

    center();
    window.addEventListener('resize', function(){ setX(currentOffset); }, {passive:true});

    character.addEventListener('pointerdown', function(e){
      dragging = true;
      startX = e.clientX;
      startOffset = currentOffset;
      character.classList.add('is-dragging');
      if(character.setPointerCapture) character.setPointerCapture(e.pointerId);
    });
    character.addEventListener('pointermove', function(e){
      if(!dragging) return;
      setX(startOffset + (e.clientX - startX));
    });
    function endDrag(e){
      if(!dragging) return;
      dragging = false;
      character.classList.remove('is-dragging');
      if(e && character.releasePointerCapture){ try{ character.releasePointerCapture(e.pointerId); }catch(_err){} }
    }
    character.addEventListener('pointerup', endDrag);
    character.addEventListener('pointercancel', endDrag);

    character.addEventListener('keydown', function(e){
      var step = e.shiftKey ? 40 : 18;
      if(e.key === 'ArrowLeft'){ e.preventDefault(); setX(currentOffset-step); }
      if(e.key === 'ArrowRight'){ e.preventDefault(); setX(currentOffset+step); }
      if(e.key === 'Home'){ e.preventDefault(); setX(0); }
      if(e.key === 'End'){ e.preventDefault(); setX(bounds()); }
    });

    function moveEyes(clientX, clientY){
      var r = character.getBoundingClientRect();
      var cx = r.left + r.width/2;
      var cy = r.top + 105;
      var dx = clientX-cx, dy = clientY-cy;
      var len = Math.sqrt(dx*dx+dy*dy) || 1;
      var mag = Math.min(8, len/35);
      var ex = dx/len*mag;
      var ey = dy/len*mag;
      eyes.forEach(function(eye){ eye.style.setProperty('--eye-x', ex.toFixed(2)+'px'); eye.style.setProperty('--eye-y', ey.toFixed(2)+'px'); });
    }
    document.addEventListener('pointermove', function(e){ if(!dragging) moveEyes(e.clientX,e.clientY); }, {passive:true});

    function validEmail(){ return input.value.trim() !== '' && input.checkValidity(); }
    function setError(on){ root.classList.toggle('has-error', !!on); }
    input.addEventListener('input', function(){ if(validEmail()) setError(false); });
    input.addEventListener('blur', function(){ if(input.value.trim() !== '') setError(!validEmail()); });
    form.addEventListener('submit', function(e){
      if(!validEmail()){
        e.preventDefault();
        setError(true);
        input.focus();
        if(typeof input.reportValidity === 'function') input.reportValidity();
      } else {
        setError(false);
      }
    });

    if(form.querySelector('.jschar-server-error')) setError(true);
  }

  function initAll(){
    applyProductWaveBackground();
    document.querySelectorAll('[data-jschar-subscribe]').forEach(init);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
